import { render } from "./SaasDraggable.vue?vue&type=template&id=3baae318"
import script from "./SaasDraggable.vue?vue&type=script&lang=js"
export * from "./SaasDraggable.vue?vue&type=script&lang=js"

import "./SaasDraggable.vue?vue&type=style&index=0&id=3baae318&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__